import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { CSVParseResult } from '~utils/csv/csvProcessor';

interface CSVParseSummaryProps {
  parseResult: CSVParseResult;
  sx?: SxProps<Theme>;
}

export function CSVParseSummary({ parseResult, sx }: CSVParseSummaryProps) {
  const invalidRowCount = parseResult.invalidRows.length;

  return (
    <Typography variant="body2" sx={sx}>
      {t('csv_import_export.valid_rows_ready', { count: parseResult.validRows.length })}
      {invalidRowCount > 0 && (
        <Typography component="span" sx={{ color: 'error.main' }}>
          {' '}
          {t('csv_import_export.rows_have_errors', { count: invalidRowCount })}
        </Typography>
      )}
    </Typography>
  );
}
